module.exports = __webpack_public_path__ + "5b52b82b39f93d4b7cf0eb7c43cf7785.ttf";